'use strict';

angular.module('atex.dam').filter('fields', function() {
  return function(value, tab) {
    var result = [];

    tab = tab || 'general';

    if (!value || !angular.isArray(value)) {
      return value;
    }

    _.each(value, function(field) {
      if (tab === 'general') {
        if (field.type !== 'metadata') {
          result.push(field);
        }
      }

      if (tab === 'extras') {
        if (field.type === 'metadata') {
          result.push(field);
        }
      }
    });

    return result;
  };
});
